import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import util from '@utils/utils';

export const useUser = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // 检查用户登录状态
  const checkAuth = useCallback(() => {
    try {
      const userInfo = util.getStorage(process.env.REACT_APP_LOCALSTORAGE_NAME);
      console.log('useUser checkAuth - 检查到的用户信息:', userInfo);
      console.log('用户ID类型:', typeof userInfo?.id);
      console.log('用户ID长度:', userInfo?.id ? String(userInfo.id).length : 0);
      
      if (userInfo && (userInfo.id || userInfo.userId || userInfo.phoneNumber)) {
        setUser(userInfo);
        return true;
      } else {
        setUser(null);
        return false;
      }
    } catch (error) {
      console.error('Auth check error:', error);
      setUser(null);
      return false;
    }
  }, []);

  // 初始化时检查登录状态
  useEffect(() => {
    const isAuthenticated = checkAuth();
    setIsLoading(false);
    
    // 只有在没有用户信息且不在登录页时才重定向
    if (!isAuthenticated && window.location.pathname !== '/login') {
      navigate('/login', { replace: true });
    }
  }, [checkAuth, navigate]);

  // 登录
  const login = useCallback((userData) => {
    try {
      console.log('useUser login - 准备存储用户数据:', userData);
      util.setStorage(process.env.REACT_APP_LOCALSTORAGE_NAME, userData);
      setUser(userData);
      console.log('useUser login - 用户数据已存储，准备跳转');
      navigate('/policy');
      return true;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  }, [navigate]);

  // 登出
  const logout = useCallback(() => {
    try {
      util.removeStorage(process.env.REACT_APP_LOCALSTORAGE_NAME);
      setUser(null);
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
    }
  }, [navigate]);

  // 刷新用户信息
  const refreshUser = useCallback(() => {
    return checkAuth();
  }, [checkAuth]);

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    login,
    logout,
    refreshUser,
    checkAuth
  };
}; 